import { Variants } from 'motion/react';

export const fadeUpVariant: Variants = {
  hidden:  { opacity: 0, y: 32 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: [0.16, 1, 0.3, 1] },
  },
};

export const fadeInVariant: Variants = {
  hidden:  { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.5, ease: 'easeOut' },
  },
};

export const cardVariant: Variants = {
  hidden:  { opacity: 0, y: 24, scale: 0.97 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1] },
  },
};

export const slideInLeft: Variants = {
  hidden:  { opacity: 0, x: -48 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.65, ease: [0.16, 1, 0.3, 1] },
  },
};

export const slideInRight: Variants = {
  hidden:  { opacity: 0, x: 64 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
  },
};

export const staggerContainer: Variants = {
  hidden:  {},
  visible: {
    transition: {
      staggerChildren: 0.09,
      delayChildren:   0.05,
    },
  },
};

// Faster stagger for skill pills / dense grids
export const quickStagger: Variants = {
  hidden:  {},
  visible: {
    transition: {
      staggerChildren: 0.04,
      delayChildren:   0.0,
    },
  },
};

export const reducedFadeVariant: Variants = {
  hidden:  { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.01 } },
};

export const reducedStagger: Variants = {
  hidden:  {},
  visible: { transition: { staggerChildren: 0.01 } },
};

// ── Word-by-word reveal ────────────────────────────────────────────────────────
export const wordRevealContainer: Variants = {
  hidden:  {},
  visible: {
    transition: { staggerChildren: 0.055, delayChildren: 0.1 },
  },
};

export const wordRevealChild: Variants = {
  hidden:  { opacity: 0, y: '110%', rotateX: -30 },
  visible: {
    opacity: 1,
    y:       '0%',
    rotateX: 0,
    transition: { duration: 0.65, ease: [0.16, 1, 0.3, 1] },
  },
};

// ── Cinematic section entry ────────────────────────────────────────────────────
export const cinematicEntry: Variants = {
  hidden:  { opacity: 0, y: 80, scale: 0.96 },
  visible: {
    opacity: 1,
    y:       0,
    scale:   1,
    transition: { duration: 0.85, ease: [0.16, 1, 0.3, 1] },
  },
};

// ── Dramatic stagger (slower, more cinematic) ──────────────────────────────────
export const dramaticStagger: Variants = {
  hidden:  {},
  visible: {
    transition: { staggerChildren: 0.14, delayChildren: 0.08 },
  },
};

// ── Experience timeline card ───────────────────────────────────────────────────
export const timelineCardVariant: Variants = {
  hidden:  { opacity: 0, x: -40 },
  visible: {
    opacity: 1,
    x:       0,
    transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
  },
};

// ── Featured project card ──────────────────────────────────────────────────────
export const featuredCardVariant: Variants = {
  hidden:  { opacity: 0, y: 48, scale: 0.94 },
  visible: {
    opacity: 1,
    y:       0,
    scale:   1,
    transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
  },
};
